export const RESET = 'PREMIUM_RESET'

export const SELECT_PRODUCT = 'SELECT_PRODUCT'

export const FETCH_USER_COUPONS = 'FETCH_USER_COUPONS'
export const FETCH_USER_COUPONS_LOADING = 'FETCH_USER_COUPONS_LOADING'
export const FETCH_USER_COUPONS_SUCCESS = 'FETCH_USER_COUPONS_SUCCESS'
export const FETCH_USER_COUPONS_ERROR = 'FETCH_USER_COUPONS_ERROR'

export const CREATE_STRIPE_TOKEN = 'CREATE_STRIPE_TOKEN'
export const CREATE_STRIPE_TOKEN_LOADING = 'CREATE_STRIPE_TOKEN_LOADING'
export const CREATE_STRIPE_TOKEN_SUCCESS = 'CREATE_STRIPE_TOKEN_SUCCESS'
export const CREATE_STRIPE_TOKEN_ERROR = 'CREATE_STRIPE_TOKEN_ERROR'

export const CREATE_USER_COUPON = 'CREATE_USER_COUPON'
export const CREATE_USER_COUPON_LOADING = 'CREATE_USER_COUPON_LOADING'
export const CREATE_USER_COUPON_SUCCESS = 'CREATE_USER_COUPON_SUCCESS'
export const CREATE_USER_COUPON_ERROR = 'CREATE_USER_COUPON_ERROR'

export const CREATE_PAID_SUBSCRIPTION = 'CREATE_PAID_SUBSCRIPTION'
export const CREATE_PAID_SUBSCRIPTION_LOADING = 'CREATE_PAID_SUBSCRIPTION_LOADING'
export const CREATE_PAID_SUBSCRIPTION_SUCCESS = 'CREATE_PAID_SUBSCRIPTION_SUCCESS'
export const CREATE_PAID_SUBSCRIPTION_ERROR = 'CREATE_PAID_SUBSCRIPTION_ERROR'

export const CREATE_BILLING_PROFILE = 'CREATE_BILLING_PROFILE'
export const CREATE_BILLING_PROFILE_LOADING = 'CREATE_BILLING_PROFILE_LOADING'
export const CREATE_BILLING_PROFILE_SUCCESS = 'CREATE_BILLING_PROFILE_SUCCESS'
export const CREATE_BILLING_PROFILE_ERROR = 'CREATE_BILLING_PROFILE_ERROR'

export const ADD_BILLING_PROFILE = 'ADD_BILLING_PROFILE'
export const ADD_BILLING_PROFILE_LOADING = 'ADD_BILLING_PROFILE_LOADING'
export const ADD_BILLING_PROFILE_SUCCESS = 'ADD_BILLING_PROFILE_SUCCESS'
export const ADD_BILLING_PROFILE_ERROR = 'ADD_BILLING_PROFILE_ERROR'

export const FETCH_BILLING_PROFILES = 'FETCH_BILLING_PROFILES'
export const FETCH_BILLING_PROFILES_LOADING = 'FETCH_BILLING_PROFILES_LOADING'
export const FETCH_BILLING_PROFILES_SUCCESS = 'FETCH_BILLING_PROFILES_SUCCESS'
export const FETCH_BILLING_PROFILES_ERROR = 'FETCH_BILLING_PROFILES_ERROR'

export const FETCH_PRODUCTS = 'FETCH_PRODUCTS'
export const FETCH_PRODUCTS_LOADING = 'FETCH_PRODUCTS_LOADING'
export const FETCH_PRODUCTS_SUCCESS = 'FETCH_PRODUCTS_SUCCESS'
export const FETCH_PRODUCTS_ERROR = 'FETCH_PRODUCTS_ERROR'

export const FETCH_PAID_SUBSCRIPTIONS = 'FETCH_PAID_SUBSCRIPTIONS'
export const FETCH_PAID_SUBSCRIPTIONS_LOADING = 'FETCH_PAID_SUBSCRIPTIONS_LOADING'
export const FETCH_PAID_SUBSCRIPTIONS_SUCCESS = 'FETCH_PAID_SUBSCRIPTIONS_SUCCESS'
export const FETCH_PAID_SUBSCRIPTIONS_ERROR = 'FETCH_PAID_SUBSCRIPTIONS_ERROR'

export const DISABLE_AUTO_RENEW = 'DISABLE_AUTO_RENEW'
export const DISABLE_AUTO_RENEW_LOADING = 'DISABLE_AUTO_RENEW_LOADING'
export const DISABLE_AUTO_RENEW_SUCCESS = 'DISABLE_AUTO_RENEW_SUCCESS'
export const DISABLE_AUTO_RENEW_ERROR = 'DISABLE_AUTO_RENEW_ERROR'

export const APPLY_COUPON = 'APPLY_COUPON'
export const APPLY_COUPON_LOADING = 'APPLY_COUPON_LOADING'
export const APPLY_COUPON_SUCCESS = 'APPLY_COUPON_SUCCESS'
export const APPLY_COUPON_ERROR = 'APPLY_COUPON_ERROR'

export const FETCH_COUPON = 'FETCH_COUPON'
export const FETCH_COUPON_LOADING = 'FETCH_COUPON_LOADING'
export const FETCH_COUPON_SUCCESS = 'FETCH_COUPON_SUCCESS'
export const FETCH_COUPON_ERROR = 'FETCH_COUPON_ERROR'

export const FETCH_PRODUCT = 'FETCH_PRODUCT'
export const FETCH_PRODUCT_LOADING = 'FETCH_PRODUCT_LOADING'
export const FETCH_PRODUCT_SUCCESS = 'FETCH_PRODUCT_SUCCESS'
export const FETCH_PRODUCT_ERROR = 'FETCH_PRODUCT_ERROR'

// user flows

export const CHECKOUT_WITH_CARD = 'CHECKOUT_WITH_CARD'
export const CHECKOUT_WITH_CARD_LOADING = 'CHECKOUT_WITH_CARD_LOADING'
export const CHECKOUT_WITH_CARD_SUCCESS = 'CHECKOUT_WITH_CARD_SUCCESS'
export const CHECKOUT_WITH_CARD_ERROR = 'CHECKOUT_WITH_CARD_ERROR'

export const CHECKOUT_WITH_PROMO = 'CHECKOUT_WITH_PROMO'
export const CHECKOUT_WITH_PROMO_LOADING = 'CHECKOUT_WITH_PROMO_LOADING'
export const CHECKOUT_WITH_PROMO_SUCCESS = 'CHECKOUT_WITH_PROMO_SUCCESS'
export const CHECKOUT_WITH_PROMO_ERROR = 'CHECKOUT_WITH_PROMO_ERROR'

export const CHECKOUT_WITH_EXISTING = 'CHECKOUT_WITH_EXISTING'
export const CHECKOUT_WITH_EXISTING_LOADING = 'CHECKOUT_WITH_EXISTING_LOADING'
export const CHECKOUT_WITH_EXISTING_SUCCESS = 'CHECKOUT_WITH_EXISTING_SUCCESS'
export const CHECKOUT_WITH_EXISTING_ERROR = 'CHECKOUT_WITH_EXISTING_ERROR'

export const UPDATE_AUTO_RENEW = 'UPDATE_AUTO_RENEW'
export const UPDATE_AUTO_RENEW_LOADING = 'UPDATE_AUTO_RENEW_LOADING'
export const UPDATE_AUTO_RENEW_SUCCESS = 'UPDATE_AUTO_RENEW_SUCCESS'
export const UPDATE_AUTO_RENEW_ERROR = 'UPDATE_AUTO_RENEW_ERROR'

export const DELETE_BILLING_PROFILE = 'DELETE_BILLING_PROFILE'
export const DELETE_BILLING_PROFILE_LOADING = 'DELETE_BILLING_PROFILE_LOADING'
export const DELETE_BILLING_PROFILE_SUCCESS = 'DELETE_BILLING_PROFILE_SUCCESS'
export const DELETE_BILLING_PROFILE_ERROR = 'DELETE_BILLING_PROFILE_ERROR'

export const ADD_CARD = 'ADD_CARD'
export const ADD_CARD_LOADING = 'ADD_CARD_LOADING'
export const ADD_CARD_SUCCESS = 'ADD_CARD_SUCCESS'
export const ADD_CARD_ERROR = 'ADD_CARD_ERROR'

export const UPDATE_DEFAULT_BILLING_PROFILE = 'UPDATE_DEFAULT_BILLING_PROFILE'
export const UPDATE_DEFAULT_BILLING_PROFILE_LOADING = 'UPDATE_DEFAULT_BILLING_PROFILE_LOADING'
export const UPDATE_DEFAULT_BILLING_PROFILE_SUCCESS = 'UPDATE_DEFAULT_BILLING_PROFILE_SUCCESS'
export const UPDATE_DEFAULT_BILLING_PROFILE_ERROR = 'UPDATE_DEFAULT_BILLING_PROFILE_ERROR'

export const CHECKOUT = 'CHECKOUT'
export const CHECKOUT_LOADING = 'CHECKOUT_LOADING'
export const CHECKOUT_SUCCESS = 'CHECKOUT_SUCCESS'
export const CHECKOUT_ERROR = 'CHECKOUT_ERROR'

export const CHECKOUT_PAGE = 'CHECKOUT_PAGE'
export const CHECKOUT_PAGE_LOADING = 'CHECKOUT_PAGE_LOADING'
export const CHECKOUT_PAGE_SUCCESS = 'CHECKOUT_PAGE_SUCCESS'
export const CHECKOUT_PAGE_ERROR = 'CHECKOUT_PAGE_ERROR'

export const SUBSCRIPTION_SETTINGS = 'SUBSCRIPTION_SETTINGS'
export const SUBSCRIPTION_SETTINGS_LOADING = 'SUBSCRIPTION_SETTINGS_LOADING'
export const SUBSCRIPTION_SETTINGS_SUCCESS = 'SUBSCRIPTION_SETTINGS_SUCCESS'
export const SUBSCRIPTION_SETTINGS_ERROR = 'SUBSCRIPTION_SETTINGS_ERROR'

export const PROCESS_COUPON = 'PROCESS_COUPON'
export const PROCESS_COUPON_LOADING = 'PROCESS_COUPON_LOADING'
export const PROCESS_COUPON_SUCCESS = 'PROCESS_COUPON_SUCCESS'
export const PROCESS_COUPON_ERROR = 'PROCESS_COUPON_ERROR'

export const REDEEM_COUPON = 'REDEEM_COUPON'
export const REDEEM_COUPON_LOADING = 'REDEEM_COUPON_LOADING'
export const REDEEM_COUPON_SUCCESS = 'REDEEM_COUPON_SUCCESS'
export const REDEEM_COUPON_ERROR = 'REDEEM_COUPON_ERROR'

export const UPDATE_BILLING_PROFILE = 'UPDATE_BILLING_PROFILE'
export const UPDATE_BILLING_PROFILE_LOADING = 'UPDATE_BILLING_PROFILE_LOADING'
export const UPDATE_BILLING_PROFILE_SUCCESS = 'UPDATE_BILLING_PROFILE_SUCCESS'
export const UPDATE_BILLING_PROFILE_ERROR = 'UPDATE_BILLING_PROFILE_ERROR'
